import type { FC } from 'react';

import Grid2 from '@mui/material/Unstable_Grid2';

import TextAction from '@/components/text-action/TextAction';
import { DisplayField } from '@/components/typography/DisplayField';
import { t } from '@/utils/lang';

const CustomerInfo: FC<{ data: any }> = ({ data }) => {
    return (
        <Grid2 container spacing={6}>
            <DisplayField
                xs={4}
                label={
                    <TextAction value={data?.customerRepresentativeName} copy>
                        {t('Khách hàng đại diện')}
                    </TextAction>
                }
                value={data?.customerRepresentativeName}
            />
            <DisplayField
                xs={4}
                label={
                    <TextAction
                        value={data?.customerRepresentativePhoneNumber}
                        copy
                    >
                        {t('SDT khách hàng đại diện')}
                    </TextAction>
                }
                value={data?.customerRepresentativePhoneNumber}
            />
            <DisplayField
                xs={4}
                label={
                    <TextAction value={data?.phoneNumber} copy>
                        {t('SDT công ty')}
                    </TextAction>
                }
                value={data?.phoneNumber}
            />
            <DisplayField
                xs={4}
                label={
                    <TextAction value={data?.email} copy>
                        {t('Email')}
                    </TextAction>
                }
                value={data?.email}
            />

            <DisplayField
                xs={4}
                label={
                    <TextAction value={data.address} address copy>
                        {t('Địa chỉ')}
                    </TextAction>
                }
                value={
                    <div
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                        }}
                    >
                        <span>{data?.address}</span>
                    </div>
                }
            />

            <DisplayField
                xs={4}
                label={
                    <TextAction value={data?.description} copy>
                        {t('Mô tả')}
                    </TextAction>
                }
                value={data?.description}
            />
        </Grid2>
    );
};

export default CustomerInfo;
